// add the beginning of your app entry
import 'vite/modulepreload-polyfill'

import 'tailwindcss/base.css'

import './utils/section-readmore'
import './utils/hbox-readmore'
import './utils/share-reorder'
import './utils/fix-asiagohockey'

import './components/cntass-scope-article-box'

import './vue-components/minisites-info'
import './vue-components/forms'
import './vue-components/forms-popup'
import './vue-components/button-phone'
import './vue-components/button-url'
import './vue-components/best-price-guaranteed'
import './vue-components/realestate'
import './vue-components/short-url-embed'
import './vue-components/cancel-postpone-event-text'

import './components/stati-apertura-chiusura'
import './components/consorzio-asiago-aziende'
// import './components/minisite-service-anchor'
import './components/consorzio-minisite-malghe-anchor'
import './components/banner-malghe'
import './components/banner-generic'
import './components/banner-snowbulletin'
import './components/auto-lightbox-cms-user-content'
import './components/socialpopup'
import './components/banner-ebike-rental'
import './components/banner-ebike'
import './components/trails-gpx-download'
import './components/trails-print'
import './components/cfac-btn'
import './components/menu-toggle-submenus'
import './components/banner-agenzie-immobiliari'
import './components/agenzie-immobiliari-move-maps'
import './components/municipality-realestate-links'
import './components/banner-punto-sport'
import './components/banner-asiagohockey'
import './components/syfb-banner-itinerari'
import './components/trails-api'
import './components/webcams-mobile-order'
import './components/cin-show-more'
import './components/gallery-masonry'

import '../styles/main.scss'

//
;(async () => {
  const meta = document.createElement('meta')
  meta.name = 'naive-ui-style'
  document.head.appendChild(meta)

  await import('~/default/styles/overrides/naive.scss')
  await import('~/default/styles/overrides/tailwind.css')

  window.cmsVueComponentsReady = true
  document.dispatchEvent(new CustomEvent('cmsVueComponentsReady'))
})()
